import { CornerDownLeft } from "lucide-react";
import { Button } from "../ui/button";

export default function EnterButton({
    isSubmitting,
    children,
    disabled,
    type = "submit",
    nativeButton = true,
    size = "sm",
    ...props
}: {
    isSubmitting: boolean;
    type?: "submit" | "button";
    nativeButton?: boolean;
    children: React.ReactNode;
    disabled?: boolean;
    size?: "sm" | "default" | "lg";
    ref?: React.RefObject<HTMLButtonElement | null>;
} & React.ComponentProps<typeof Button>) {
    return (
        <Button type={type} nativeButton={nativeButton} disabled={isSubmitting || disabled} size={size} {...props}>
            {isSubmitting ? "Creating..." : children}
            <CornerDownLeft className="text-white/50" />
        </Button>
    );
}
